<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <h2 mat-dialog-title>
    {{ "subjectEditDialog." + (update ? "editSerial" : "newSerial") | translate }}
    <ng-container *ngIf="!update">{{ serialNumberLabel }}</ng-container>
  </h2>

  <div class="subject-tabs-box">
    <nav mat-tab-nav-bar *ngIf="update && !isEditAttrOnly && visibleAttrExists">
      <a mat-tab-link [active]="selectedTab === 'SN'" (click)="onClickTab('SN')">
        {{ serialNumberLabel }}
      </a>
      <a mat-tab-link [active]="selectedTab === 'Attributes'" (click)="onClickTab('Attributes')">
        {{ "subjectEditDialog.attributes" | translate }}
      </a>
    </nav>
  </div>

  <div fxLayout="column" *ngIf="hasInspections && selectedTab === 'Attributes'" class="confirm-txt-box">
    <span class="used-message">
      {{ "subjectEditDialog.confirmText1" | translate }}
      {{ "subjectEditDialog.confirmText2" | translate }}
    </span>
  </div>

  <div class="form-container" fxLayout="column" fxLayoutAlign="start start">
    <div class="serial-content" fxLayout="row wrap" fxLayoutAlign="start">
      <!-- Subject Model -->
      <mat-form-field class="subject-mat-form" *ngIf="modelSelectable">
        <mat-label class="top-label">{{ "subjectEditDialog.modelPlaceholder" | translate }}</mat-label>
        <mat-select hideSingleSelectionIndicator [formControl]="subjectModelForm" required>
          <mat-option *ngFor="let model of subjectModels" [value]="model.id">
            <span class="option-label-overflow" [matTooltip]="model.name" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
              {{ model.name }}
            </span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="subjectModelForm.hasError('required')">{{ "subjectEditDialog.modelRequired" | translate }}</mat-error>
      </mat-form-field>

      <!-- Serial Number -->
      <mat-form-field class="subject-mat-form" *ngIf="!update || selectedTab === 'SN'">
        <mat-label class="top-label">{{ serialNumberLabel }}</mat-label>
        <input matInput maxlength="{{ serialMaxLength }}" [formControl]="serialNumberForm" required />
        <mat-hint align="end">{{ serialNumberForm.value?.length || 0 }}/{{ serialMaxLength }}</mat-hint>
        <mat-error *ngIf="serialNumberForm.hasError('required')">
          {{ getRequiredErrorText(serialNumberLabel) }}
        </mat-error>
        <mat-error *ngIf="serialNumberForm.hasError('maxlength')">
          {{ "subjectEditDialog.serialNumberMaxRequired" | translate: { serialMaxLength: serialMaxLength } }}
        </mat-error>
        <mat-error *ngIf="serialNumberForm.hasError('pattern') && !serialNumberForm.hasError('required')">
          {{ getValidErrorText(serialNumberLabel) }}
        </mat-error>
      </mat-form-field>
      <ng-container *ngIf="serialNumberForm.value && isContainKanjiForSerial">
        <div class="insp-title-format-confirm">
          {{ "subjectEditDialog.includeKanjiMessage" | translate: { serialNumber: serialNumberLabel } }} {{ regularExpressionStr }}
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="!update || selectedTab === 'Attributes'">
      <div fxLayout="row wrap" *ngIf="!isHide(ownerKey)" [class.parse-line]="!update" fxLayoutAlign="start">
        <!-- Owner -->
        <mat-form-field class="subject-mat-form" *ngIf="!isHide(ownerKey)">
          <mat-label class="top-label">{{ ownerLabel }}</mat-label>
          <input matInput maxlength="{{ serialMaxLength }}" [formControl]="ownerForm" [required]="isRequired(ownerKey)" />
          <mat-hint align="end">{{ ownerForm.value?.length || 0 }}/{{ serialMaxLength }}</mat-hint>
          <mat-error *ngIf="ownerForm.hasError('required')">
            {{ getRequiredErrorText(ownerLabel) }}
          </mat-error>
          <mat-error *ngIf="ownerForm.hasError('maxlength')">
            {{ "subjectEditDialog.ownerMaxRequired" | translate: { serialMaxLength: serialMaxLength } }}
          </mat-error>
          <mat-error *ngIf="ownerForm.hasError('pattern') && !ownerForm.hasError('required')">
            {{ getValidErrorText(ownerLabel) }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        fxLayout="row wrap"
        *ngIf="!isHide(countryKey) || !isHide(stateKey) || !isHide(districtKey)"
        fxLayoutAlign="start"
        [class.parse-line]="isHide(ownerKey)"
      >
        <!-- Country -->
        <mat-form-field class="subject-mat-form" *ngIf="!isHide(countryKey)">
          <mat-label class="top-label">{{ countryLabel }}</mat-label>
          <input matInput maxlength="{{ serialMaxLength }}" [formControl]="countryForm" [required]="isRequired(countryKey)" />
          <mat-hint align="end">{{ countryForm.value?.length || 0 }}/{{ serialMaxLength }}</mat-hint>
          <mat-error *ngIf="countryForm.hasError('required')">
            {{ getRequiredErrorText(countryLabel) }}
          </mat-error>
          <mat-error *ngIf="countryForm.hasError('maxlength')">
            {{ "subjectEditDialog.countryMaxRequired" | translate: { serialMaxLength: serialMaxLength } }}
          </mat-error>
          <mat-error *ngIf="countryForm.hasError('pattern') && !countryForm.hasError('required')">
            {{ getValidErrorText(countryLabel) }}
          </mat-error>
        </mat-form-field>

        <!-- State -->
        <mat-form-field class="subject-mat-form" *ngIf="!isHide(stateKey)">
          <mat-label class="top-label">{{ stateLabel }}</mat-label>
          <input matInput maxlength="{{ serialMaxLength }}" [formControl]="stateForm" [required]="isRequired(stateKey)" />
          <mat-hint align="end">{{ stateForm.value?.length || 0 }}/{{ serialMaxLength }}</mat-hint>
          <mat-error *ngIf="stateForm.hasError('required')">
            {{ getRequiredErrorText(stateLabel) }}
          </mat-error>
          <mat-error *ngIf="stateForm.hasError('maxlength')">
            {{ "subjectEditDialog.stateMaxRequired" | translate: { serialMaxLength: serialMaxLength } }}
          </mat-error>
          <mat-error *ngIf="stateForm.hasError('pattern') && !stateForm.hasError('required')">
            {{ getValidErrorText(stateLabel) }}
          </mat-error>
        </mat-form-field>

        <!-- District -->
        <mat-form-field class="subject-mat-form" *ngIf="!isHide(districtKey)">
          <mat-label class="top-label">{{ districtLabel }}</mat-label>
          <input matInput maxlength="{{ serialMaxLength }}" [formControl]="districtForm" [required]="isRequired(districtKey)" />
          <mat-hint align="end">{{ districtForm.value?.length || 0 }}/{{ serialMaxLength }}</mat-hint>
          <mat-error *ngIf="districtForm.hasError('required')">
            {{ getRequiredErrorText(districtLabel) }}
          </mat-error>
          <mat-error *ngIf="districtForm.hasError('maxlength')">
            {{ "subjectEditDialog.districtMaxRequired" | translate: { serialMaxLength: serialMaxLength } }}
          </mat-error>
          <mat-error *ngIf="districtForm.hasError('pattern') && !districtForm.hasError('required')">
            {{ getValidErrorText(districtLabel) }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        fxLayout="row wrap"
        *ngIf="!isHide(siteKey) || !isHide(projectKey)"
        fxLayoutAlign="start"
        [class.parse-line]="isHide(ownerKey) && isHide(countryKey) && isHide(stateKey) && isHide(districtKey)"
      >
        <!-- Site -->
        <mat-form-field class="subject-mat-form" *ngIf="!isHide(siteKey)">
          <mat-label class="top-label">{{ siteLabel }}</mat-label>
          <input matInput maxlength="{{ serialMaxLength }}" [formControl]="siteForm" [required]="isRequired(siteKey)" />
          <mat-hint align="end">{{ siteForm.value?.length || 0 }}/{{ serialMaxLength }}</mat-hint>
          <mat-error *ngIf="siteForm.hasError('required')">
            {{ getRequiredErrorText(siteLabel) }}
          </mat-error>
          <mat-error *ngIf="siteForm.hasError('maxlength')">
            {{ "subjectEditDialog.siteMaxRequired" | translate: { serialMaxLength: serialMaxLength } }}
          </mat-error>
          <mat-error *ngIf="siteForm.hasError('pattern') && !siteForm.hasError('required')">
            {{ getValidErrorText(siteLabel) }}
          </mat-error>
        </mat-form-field>

        <!-- Project -->
        <mat-form-field class="subject-mat-form" *ngIf="!isHide(projectKey)">
          <mat-label class="top-label">{{ projectLabel }}</mat-label>
          <input matInput maxlength="{{ serialMaxLength }}" [formControl]="projectForm" [required]="isRequired(projectKey)" />
          <mat-hint align="end">{{ projectForm.value?.length || 0 }}/{{ serialMaxLength }}</mat-hint>
          <mat-error *ngIf="projectForm.hasError('required')">
            {{ getRequiredErrorText(projectLabel) }}
          </mat-error>
          <mat-error *ngIf="projectForm.hasError('maxlength')">
            {{ "subjectEditDialog.projectMaxRequired" | translate: { serialMaxLength: serialMaxLength } }}
          </mat-error>
          <mat-error *ngIf="projectForm.hasError('pattern') && !projectForm.hasError('required')">
            {{ getValidErrorText(projectLabel) }}
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <div [style.visibility]="!update || selectedTab === 'SN' ? 'visible' : 'hidden'" fxLayout="row" fxLayoutAlign="start">
      <mat-slide-toggle color="primary">
        <div>{{ toggleText }}</div>
      </mat-slide-toggle>
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <mat-dialog-actions>
      <button mat-button color="primary" mat-dialog-close>{{ "subjectEditDialog.cancel" | translate }}</button>
      <button mat-raised-button color="primary" [disabled]="isDisabledSubmit()" (click)="submit()">
        {{ "subjectEditDialog." + (hasInspections && attrChanged ? "saveNewVersion" : "save") | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
